import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import supabase from '../../supabase/supabase';

const { FiUserPlus, FiShield, FiTrash2, FiUser } = FiIcons;

export default function CustomRolesManager() {
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedRole, setSelectedRole] = useState('moderator');
  const [rolesList, setRolesList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRolesAndUsers();
  }, []);

  const fetchRolesAndUsers = async () => {
    const { data: roles } = await supabase
      .from('gallo_roles_1786733905424')
      .select('*')
      .order('created_at', { ascending: false });
    if (roles) {
      setRolesList(roles);
    }
  };

  const handleAssignRole = async (e) => {
    e.preventDefault();
    if (!selectedUser.trim()) return;
    setLoading(true);

    const { error } = await supabase
      .from('gallo_roles_1786733905424')
      .insert({
        user_id: crypto.randomUUID(),
        username: selectedUser.trim(),
        role: selectedRole
      });

    if (!error) {
      setSelectedUser('');
      fetchRolesAndUsers();
    }
    setLoading(false);
  };

  const handleRemoveRole = async (id) => {
    if (window.confirm('¿Seguro que deseas remover el rol de este usuario?')) {
      await supabase.from('gallo_roles_1786733905424').delete().eq('id', id);
      fetchRolesAndUsers();
    }
  };

  return (
    <section className="rounded-2xl border border-white/10 bg-[#111] p-5 space-y-6">
      <div>
        <h3 className="font-semibold text-white text-sm sm:text-base flex items-center gap-2">
          <SafeIcon icon={FiShield} className="text-red-500" />
          Roles de Moderación Personalizados
        </h3>
        <p className="text-xs text-gray-500 mt-0.5">
          Asigna roles de Administrador, Moderador o Colaborador para que otros miembros te ayuden a gestionar el chat.
        </p>
      </div>

      <form onSubmit={handleAssignRole} className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-semibold text-gray-400 mb-1.5">Nombre de Usuario / Apodo</label>
            <input
              type="text"
              required
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
              placeholder="Ej. JuanModerador"
              className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-2.5 text-xs text-white focus:border-red-600 focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-400 mb-1.5">Rol de Permisos</label>
            <select
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              className="w-full rounded-xl border border-white/10 bg-[#151515] px-4 py-2.5 text-xs text-white focus:border-red-600 focus:outline-none"
            >
              <option value="admin">Administrador (Control Total)</option>
              <option value="moderator">Moderador (Limpia Chat y Expulsa)</option>
              <option value="collaborator">Colaborador (Mensajes Destacados)</option>
            </select>
          </div>
        </div>
        <button
          type="submit"
          disabled={loading || !selectedUser.trim()}
          className="w-full py-2.5 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl text-xs sm:text-sm transition-all"
        >
          <span className="flex items-center justify-center gap-1.5">
            <SafeIcon icon={FiUserPlus} size={14} />
            Asignar Rol de Equipo
          </span>
        </button>
      </form>

      <div className="border-t border-white/5 pt-5 space-y-3">
        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider">Miembros del Equipo</h4>
        <div className="space-y-2 max-h-[300px] overflow-y-auto">
          {rolesList.map((item) => (
            <div key={item.id} className="flex items-center justify-between p-3 bg-black/40 border border-white/5 rounded-xl">
              <div className="flex items-center gap-2.5">
                <span className={`flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold ${item.role === 'admin' ? 'bg-red-600/10 text-red-500' : item.role === 'moderator' ? 'bg-blue-600/10 text-blue-400' : 'bg-yellow-600/10 text-yellow-500'}`}>
                  <SafeIcon icon={FiUser} size={12} />
                </span>
                <div>
                  <p className="text-xs font-bold text-white">@{item.username}</p>
                  <p className="text-[10px] text-gray-500 uppercase tracking-wider font-semibold">{item.role}</p>
                </div>
              </div>
              <button
                onClick={() => handleRemoveRole(item.id)}
                className="p-1.5 text-gray-500 hover:text-red-500 hover:bg-white/5 rounded transition-all"
              >
                <SafeIcon icon={FiTrash2} size={14} />
              </button>
            </div>
          ))}
          {rolesList.length === 0 && (
            <p className="text-center text-xs text-gray-600 py-4">No hay moderadores adicionales configurados.</p>
          )}
        </div>
      </div>
    </section>
  );
}